import * as React from 'react';

import {Button} from 'shells/button/button';

import type {View} from '../../../../types';

import styles from './add-card.module.css';

type Props = {
    setCurrentView: (newView: View) => void;
};

export function MoreFieldsButton(props: Props) {
    return (
        <div className={styles['all-fields']}>
            <Button variant='text-primary' onClick={() => props.setCurrentView('nutshell-fields')}>
                See more Nutshell fields
            </Button>
        </div>
    );
}
